import { Component, OnInit } from '@angular/core';
import { FormService } from 'src/app/services/form.service';
import { UntypedFormGroup } from "@angular/forms";

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

	public buttonStepNames: string[] = [];

	constructor( public formService: FormService ) {
	}

	ngOnInit(): void {

		var mainForm = this.formService.mainForm as UntypedFormGroup;

		// This step gets a finish button, so it's created manually
		var lastStepName = 'nameEmailPhone';

		// Loop over all FormGroups
		for ( let stepName in mainForm.controls ) {

			// Skip FormGroups that start with _
			if( stepName.startsWith( '_' ) ) {

				continue;
			}

			// If current step is last step
			// We skip this one as it's a submit form button
			if( stepName === lastStepName ) {

				break;
			}

			this.buttonStepNames.push( stepName );
		}
	}
}
